import { useStores } from 'stores/utils/hooks/useStores'
import { isTenantSmava } from 'utils/url'
import { VoucherBannerVariant } from '../VoucherBanner.types'
import {
  resolveFfgVoucherAmount,
  resolveLegacySmavaVoucherAmount
} from '../helpers/voucherAmount'

export const getVoucherAmount = (
  loanAmount: number,
  variant: VoucherBannerVariant
): number | null => {
  return variant === 'smava'
    ? resolveLegacySmavaVoucherAmount(loanAmount)
    : resolveFfgVoucherAmount(loanAmount)
}

const useVoucherAmount = (): number | null => {
  const { traversal } = useStores()
  const variant: VoucherBannerVariant = isTenantSmava() ? 'smava' : 'ffg'

  return getVoucherAmount(traversal.data.common.amount, variant)
}

export default useVoucherAmount
